// components/Form/FixedDropdown.tsx
import { FormField } from '../FormField';
import './fixedDropdown.css';
 
export type DropdownOption = {
  id: string;
  label: string;
};
 
type FixedDropdownProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: DropdownOption[];
  error?: string;
  placeholder?: string;
  className?: string;
};
 
export const FixedDropdown = ({
  label,
  value,
  onChange,
  options,
  error,
  placeholder = 'Seleccionar...',
  className
}: FixedDropdownProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
	onChange(e.target.value);
  };
 
  return (
	<FormField label={label} error={error} className={className}>
	  <div className="dropdown-container">
		<select
		  className="dropdown-select"
		  value={value}
		  onChange={handleChange}
		>
		  <option value="" disabled hidden>
			{placeholder}
		  </option>
		  {options.map((option) => (
			<option key={option.id} value={option.id}>
			  {option.label}
			</option>
		  ))}
		</select>
		<div className="dropdown-arrow">▼</div>
	  </div>
	</FormField>
  );
};